<template>
	<gc-dialog
		:title="operateType === 'import' ? '创建导入任务' : '创建更新任务'"
		width="760px"
		:show.sync="visible"
		@close="$emit('close-modal')"
		@cancel="$emit('close-modal')"
		@ok="handleSubmitForm"
		:okLoading="requestLoading"
	>
		<el-form :model="modelForm" :rules="rules" ref="modelForm" label-position="top" label-width="100px">
			<div class="form-block">
				<div class="title">任务内容</div>
				<el-row :gutter="12">
					<el-col :span="24">
						<el-form-item label="任务名称" prop="taskName">
							<el-input size="small" v-model="modelForm.taskName" placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
					<el-col v-if="isEtbcTenant && operateType === 'import'" :span="24">
						<el-form-item label="所属组织" prop="orgCode">
							<el-cascader
								v-model="modelForm.orgCode"
								:options="orgCodeOptions"
								:props="orgTreeProps"
								:show-all-levels="false"
								placeholder="请选择所属组织"
							></el-cascader>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="设备类型" prop="deviceTypeId">
							<el-select v-model="modelForm.deviceTypeId" placeholder="请选择" filterable>
								<el-option
									v-for="item in deviceTypeOptions"
									:key="item.value"
									:label="item.label"
									:value="item.value"
								></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="操作类型" prop="optType">
							<el-select
								v-model="modelForm.optType"
								placeholder="请选择"
								:disabled="operateType === 'update'"
							>
								<el-option
									v-for="item in operateType === 'import'
										? optTypeOptions.slice(0, 3)
										: optTypeOptions"
									:key="item.value"
									:label="item.label"
									:value="item.value"
								></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="所属区域" prop="waterRegionCode" v-if="tenantType === '1'">
							<gc-tree-select
								v-model="modelForm.waterRegionCode"
								placeholder="请选择所属区域"
								:props="{
									label: 'name',
									id: 'code',
									disabled: data => {
										return data.unSelectFlag && data.unSelectFlag === 1
									},
								}"
								:options="treeOptions"
							></gc-tree-select>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item v-if="[1, 2].includes(modelForm.optType)" label="安装地址" prop="areaCode">
							<el-cascader
								:options="locationOptions"
								v-model="modelForm.areaCode"
								placeholder="请选择"
								popper-class="gc-customer-cascader"
							></el-cascader>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="备注" prop="remark">
							<el-input
								type="textarea"
								v-model="modelForm.remark"
								placeholder="请输入备注信息"
								:rows="3"
								resize="none"
							></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</div>
			<div class="form-block">
				<div class="title">
					文件导入
					<span class="download-template" @click="handleDownloadTemplate">下载数据模板</span>
				</div>
				<el-row :gutter="12">
					<el-col :span="24">
						<el-form-item prop="fileInfo" style="margin-top: 8px">
							<el-upload
								class="btn"
								ref="upload"
								action
								drag
								:auto-upload="false"
								:show-file-list="false"
								:on-change="handleUploadFileChange"
							>
								<i class="el-icon-upload"></i>
								<div class="el-upload__text">
									将文件拖到此处，或
									<em>点击上传</em>
								</div>
							</el-upload>
						</el-form-item>
						<div v-if="modelForm.fileInfo" class="file-name">
							{{ modelForm.fileInfo.name }}（{{ modelForm.fileInfo.size }}）
							<i class="iconfont el-icon-circle-close" @click="handleRemoveExcelFile"></i>
						</div>
					</el-col>
					<el-col :span="24" :class="{ hidden: !validFailDataList.length }">
						<el-form-item>
							<div class="content-error-tip">
								<p>
									当前上传的文件有
									<span>{{ validFailDataList.length }}</span>
									条数据格式校验不通过，您可以
									<em @click="handleDownloadFailData">点击下载</em>
									查看校验不通过的数据
								</p>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
			</div>
		</el-form>
	</gc-dialog>
</template>

<script>
import { apiEditDeviceView, apiStaffsCity, apiGetDistrictList } from '@/apis/account.api'
import { apiCreateBatchImportTask } from '@/apis/batchImportTask.api'
import { apiGetOrgIsolationTree } from '@/apis/organizeRole.api'
import { exportJsonToExcel } from '@/utils/excel/newExport2Excel'
import { batchImportThead, batchUpdateThead } from '@/config/const'
import { formatExcelDate, isEtbcTenant } from '@/utils'
import { isBlank, isObject, isString, isNumber } from '@/utils/validate'
import { ruleRequired, ruleMaxLength } from '@/utils/rules'
const XLSX = require('xlsx')

export default {
	name: 'BatchImportTaskModal',
	props: {
		operateType: String,
		deviceTypeOptions: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		const adressCodeRule = (_rule, value, callback) => {
			if (value && !value[2]) {
				return callback(new Error('请选择所在省市的区'))
			}
			callback()
		}
		return {
			visible: true,
			publicPath: process.env.BASE_URL,
			requestLoading: false,
			downloadLoading: false,
			modelForm: {
				taskName: null,
				deviceTypeId: null,
				deviceTypeName: null,
				optType: this.operateType === 'import' ? 0 : 3,
				remark: null,
				areaCode: '',
				waterRegionCode: '',
				orgCode: '',
				fileInfo: null,
			},
			rules: {
				taskName: [ruleRequired(), ruleMaxLength(50)],
				deviceTypeId: [ruleRequired('请选择')],
				optType: [ruleRequired('请选择')],
				fileInfo: [ruleRequired('请先上传Excel文件')],
				areaCode: [
					ruleRequired('请选择'),
					{
						validator: adressCodeRule,
						trigger: 'change',
					},
				],
				remark: [ruleMaxLength(150)],
				waterRegionCode: [ruleRequired('请选择所属区域')],
				orgCode: [ruleRequired('请选择所属组织')],
			},
			optTypeOptions: [
				{ label: '仅新增设备', value: 0 },
				{ label: '新增并安装设备', value: 1 },
				{ label: '仅安装设备', value: 2 },
				{ label: '更新设备', value: 3 },
			],
			locationOptions: [],
			orgCodeOptions: [],
			orgTreeProps: {
				value: 'orgCode',
				label: 'name',
				children: 'children',
				emitPath: false,
			},
			templateColumns: [],
			validFailDataList: [],
		}
	},

	created() {
		this.getOrgOrTenantLocation()
		this.getOrganizationList()
	},

	methods: {
		async getOrganizationList() {
			if (!this.isEtbcTenant || this.operateType !== 'import') return
			try {
				const params = this.visibleSwitchTenant
					? {
							tenantId: this.userInfo.tenantId,
							all: 1,
					  }
					: {}
				const data = await apiGetOrgIsolationTree(params)
				this.orgCodeOptions = [data].filter(Boolean)
			} catch (error) {
				this.orgCodeOptions = []
			}
		},
		handleSubmitForm() {
			this.$refs.modelForm.validate(async valid => {
				if (valid) {
					this.validFailDataList = []
					this.requestLoading = true
					await this.handleExcelImportTemalateExcel('upload')
					const available = this.validateExcelFileContent()
					if (available) {
						const formdata = new FormData()
						for (const key in this.modelForm) {
							if (key === 'areaCode') {
								if (this.modelForm.optType > 0) {
									formdata.append('areaCode', this.modelForm[key][2])
								}
							} else if (key !== 'fileInfo') {
								!isBlank(this.modelForm[key]) && formdata.append(key, this.modelForm[key])
							}
						}
						formdata.append('file', this.modelForm.fileInfo.raw)
						try {
							await apiCreateBatchImportTask(formdata)
							this.requestLoading = false
							this.$message.success('批量任务创建成功')
							this.$emit('close-modal', true)
						} catch (error) {
							this.requestLoading = false
						}
					} else {
						this.requestLoading = false
					}
				}
			})
		},

		/**
		 * 文件上传解析获取文件内数据信息
		 * @param {*} file
		 */
		handleUploadFileChange(file) {
			const { name, size, raw } = file
			if (!/\.(xls|xlsx)$/.test(name.toLowerCase())) {
				this.$message.error('上传文件格式不正确，请上传xls或xlsx格式文档')
				return false
			}
			if (size / 1024 / 1024 > 30) {
				this.$message.error('上传文件大小不得大于30M')
				return false
			}
			const loading = this.$loading({ text: '正在读取，请等待…' })
			const fileReader = new FileReader()
			fileReader.onload = ev => {
				try {
					const data = ev.target.result
					const workbook = XLSX.read(data, {
						type: 'binary',
					})
					const sheetNames = workbook.SheetNames
					const ws = XLSX.utils.sheet_to_json(workbook.Sheets[sheetNames[0]], {
						defval: null,
					})
					if (ws.length > 50000) {
						loading.close()
						return this.$message.error('上传数据不能超过50000条')
					}
					const fileSize =
						size > 1024 * 1024
							? (size / 1024 / 1024).toFixed(1) + 'M'
							: size > 1024
							? (size / 1024).toFixed(1) + 'KB'
							: size + 'B'
					loading.close()
					this.modelForm.fileInfo = { name, size: fileSize, data: ws, raw }
					this.$refs.modelForm.clearValidate('fileInfo')
					this.validFailDataList = []
				} catch {
					loading.close()
					this.$message.error('excel读取发生错误，请重新读取')
				}
			}
			fileReader.readAsBinaryString(raw)
		},

		/**
		 * 批量导入任务模板下载
		 */
		async handleDownloadTemplate() {
			if (this.downloadLoading) return
			this.$refs.modelForm.clearValidate()
			if (this.operateType === 'import') {
				await Promise.all(
					['deviceTypeId', 'optType'].map(m => {
						return this.formValidSingleField(m)
					}),
				)
			}
			this.downloadLoading = true
			await this.handleExcelImportTemalateExcel()
			this.downloadLoading = false
		},

		/**
		 * 上传的excel文件数据格式校验
		 */
		validateExcelFileContent() {
			const datalist = this.modelForm.fileInfo.data
			if (!this.templateColumns.length) {
				this.$message.warning('请先下载需要操作的设备模板')
				return false
			}
			if (!datalist.length) {
				this.$message.warning('上传的设备数据为空')
				return false
			}
			const dataColumns = Object.keys([...datalist][0])
			if (dataColumns.length !== this.templateColumns.length) {
				this.$message.warning('上传表格与下载模板不符，请使用下载模板进行填写')
				return false
			}
			this.validFailDataList = []
			this.modelForm.deviceTypeName = this.deviceTypeOptions.find(
				item => item.value === this.modelForm.deviceTypeId,
			)?.label
			const excelColumns = [...this.templateColumns]
			const excelDataList = JSON.parse(JSON.stringify(datalist))
			const deviceNoMap = new Map()
			excelDataList.forEach((excelRowdata, index) => {
				excelRowdata['行数'] = index + 2
				excelRowdata['设备类型'] = this.modelForm.deviceTypeName
				const remark = []
				if (deviceNoMap.get(excelRowdata['设备通讯编号'])) {
					remark.push(`设备通讯编号重复`)
				} else {
					deviceNoMap.set(excelRowdata['设备通讯编号'], 1)
				}
				if (this.tenantType === '0') {
					const useTypeOptions = this.$store.getters.dataList.useTypeGas
					const inputUseTypeName = excelRowdata['使用类型']
					const inputInstallLocationName = excelRowdata['安装位置']
					if (inputUseTypeName) {
						const targetUseType = useTypeOptions.find(m => m.name === inputUseTypeName)
						if (!targetUseType) {
							remark.push(`使用类型只能输入：${useTypeOptions.map(m => m.name).join('、')}`)
						} else {
							const useTypeValue = targetUseType.defaultValue
							const installLocationOptions = this.$store.getters.dataList.installLocationGas.filter(m =>
								m.defaultValue.startsWith(useTypeValue),
							)
							if (inputInstallLocationName) {
								const targetInstallLocation = installLocationOptions.find(
									m => m.name === inputInstallLocationName,
								)
								if (!targetInstallLocation) {
									remark.push(
										`安装位置只能输入：${installLocationOptions.map(m => m.name).join('、')}`,
									)
								}
							}
						}
					}
				}
				excelColumns.forEach(item => {
					const { name, optional, lengthCheck, inputCheck, valueType, attributeKey } = item
					const value = excelRowdata[name]
					// 日期格式校验
					if (Number(valueType) === 1 && !isBlank(value)) {
						let date = value
						if (isString(value)) {
							date = this.dayjs(value).format('YYYY-MM-DD')
						} else if (isNumber(value)) {
							date = formatExcelDate(value)
						}
						const isDateFormat = /^([1-9]\d{3})-(\d{2})-(\d{2})$/.test(date)
						excelRowdata[name] = isDateFormat ? date : value
						if (!isDateFormat) remark.push(`${name}格式(YYYY-MM-DD)不正确`)
					}

					// 证书有效时间不允许填写日期格式
					if (Number(valueType) === 0 && attributeKey === 'certificateValidityPeriod') {
						const date = this.dayjs(value).format('YYYY-MM-DD')
						const isDateFormat = /^([1-9]\d{3})-(\d{2})-(\d{2})$/.test(date)
						if (isDateFormat) remark.push(`${name}不能填写日期格式`)
					}

					// 必填校验
					if (optional == 1 && isBlank(value)) remark.push(`${name}不能为空`)

					// 联动检验
					if (isObject(optional) && excelRowdata[optional.linkName] == optional?.linkValue && isBlank(value))
						remark.push(`${name}不能为空`)

					// 长度校验
					if (lengthCheck && value?.length > lengthCheck) remark.push(`${name}最大长度不能超过${lengthCheck}`)

					// 正则校验-接口返回属性
					if (inputCheck?.reg) {
						const { reg, regMsg } = inputCheck
						const pattern = typeof reg === 'string' ? new RegExp(reg) : reg
						if (!pattern.test(value) && !isBlank(value)) remark.push(regMsg)
					}

					// 正则校验
					if (inputCheck?.pattern && !inputCheck?.pattern.test(value) && !isBlank(value))
						remark.push(inputCheck?.message)

					if (remark.length) excelRowdata['异常说明'] = remark.join('；')
				})
				if (excelRowdata['异常说明']) this.validFailDataList.push(excelRowdata)
			})
			return !this.validFailDataList.length
		},

		/**
		 * 上传前模板生成或者导入模板下载
		 * @param {*} deviceViews
		 */
		async handleExcelImportTemalateExcel(type) {
			try {
				if (this.operateType === 'import') {
					const deviceViews = await apiEditDeviceView({
						deviceTypeId: this.modelForm.deviceTypeId,
						operate: 0,
					})
					const baseProductAttributes = deviceViews.baseProductAttributes || []
					const { baseAttrs, installAttrs } = batchImportThead(
						this.tenantType,
						this.modelForm.deviceTypeId,
						this.tenantId,
						deviceViews.isSupportDesignNo,
					)
					const optType = this.modelForm.optType
					// 仅安装设备时需要上传子设备数量和压力点数量
					const specialAttrs = baseProductAttributes.filter(
						item => item.attributeKey === 'subDeviceCount' || item.attributeKey === 'pressureCount',
					)
					switch (optType) {
						// 操作类型为仅新增设备
						case 0:
							this.templateColumns = [...baseAttrs, ...baseProductAttributes]
							break
						// 操作类型为新增并安装设备
						case 1:
							this.templateColumns = [...baseAttrs, ...baseProductAttributes, ...installAttrs]
							break
						// 操作类型为仅安装设备（只需填写设备通讯编号和安装信息）
						case 2:
							this.templateColumns = [...baseAttrs, ...specialAttrs, ...installAttrs]
							break
					}
				} else if (this.operateType === 'update') {
					const { baseAttrs } = batchUpdateThead()
					this.templateColumns = [...baseAttrs]
				}
				if (type === 'upload') return
				const excelCase = []
				const mustIdx = this.templateColumns.reduce((prev, cur, index) => {
					if (cur.optional === 1) {
						prev.push(index)
					}
					return prev
				}, [])
				const excelTHead = this.templateColumns.map(item => {
					const date = this.dayjs().format('YYYY/MM/DD')
					if (item.case) {
						excelCase.push(item.case)
					} else if (Number(item.valueType) === 1) {
						excelCase.push(date)
					} else if (item.attributeKey === 'airInletDirection') {
						excelCase.push('左（或右）')
					} else if (item.attributeKey === 'certificateValidityPeriod') {
						excelCase.push('1年')
					} else {
						excelCase.push('xxx')
					}
					return item.name
				})
				exportJsonToExcel(
					excelTHead,
					[excelCase],
					(this.operateType === 'import' ? '导入' : '更新') + '数据模板',
					mustIdx,
				)
				this.$message.success('模板下载成功')
			} catch (e) {
				console.log(e)
			}
		},

		handleDownloadFailData() {
			const excelDataList = []
			const excelTHead = ['行数', ...this.templateColumns.map(m => m.name), '异常说明']
			this.validFailDataList.forEach(m => {
				excelDataList.push(excelTHead.map(k => m[k]))
			})
			exportJsonToExcel(excelTHead, excelDataList, '模板异常数据')
		},

		async getOrgOrTenantLocation() {
			const { additionalInfo } = await apiStaffsCity({ tenantId: this.tenantId })
			const data = await apiGetDistrictList(additionalInfo.city)
			this.modelForm.areaCode = [additionalInfo.province, additionalInfo.city, '']
			this.locationOptions = [
				{
					label: additionalInfo.provinceName,
					value: additionalInfo.province,
					children: [
						{
							label: additionalInfo.cityName,
							value: additionalInfo.city,
							children: [
								{
									label: '',
									value: '',
								},
								...data.records.map(o => {
									return {
										label: o.regionName,
										value: o.regionCode,
									}
								}),
							],
						},
					],
				},
			]
		},

		formValidSingleField(fieldName) {
			return new Promise((resolve, reject) => {
				this.$refs.modelForm.validateField(fieldName, errorMessage => {
					if (errorMessage) {
						reject(errorMessage)
					} else {
						resolve()
					}
				})
			})
		},

		handleRemoveExcelFile() {
			this.modelForm.fileInfo = null
			this.validFailDataList = []
		},
	},

	computed: {
		isEtbcTenant() {
			return isEtbcTenant
		},

		userInfo() {
			return this.$store.getters.userInfo
		},

		visibleSwitchTenant() {
			return (
				(this.userInfo?.authRoleIds || []).includes('11') || (this.userInfo?.authRoleIds || []).includes('12')
			)
		},

		tenantId() {
			return this.$store.getters.userInfo.tenantId || null
		},

		tenantType() {
			return this.$store.getters.userInfo.tenantType || '0'
		},

		treeOptions() {
			return this.$store.getters.userRegionTree
		},
	},
}
</script>
<style lang="scss" scoped>
.form-block {
	.title {
		font-size: 17px;
		margin-bottom: 8px;
		color: #000;
		display: flex;
		justify-content: space-between;
		.download-template {
			color: #4d6bff;
			font-size: 12px;
			cursor: pointer;
		}
	}
	& + .form-block {
		margin-top: 18px;
	}
}
::v-deep .el-form-item {
	.el-upload {
		display: block;
		.el-upload-dragger {
			width: 100%;
			height: 142px;
			.el-icon-upload {
				font-size: 46px;
				margin: 30px 0 0;
			}
			.el-upload__text {
				font-size: 12px;
				line-height: 1;
			}
			.filename {
				margin-top: 52px;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				padding: 0 12px;
			}
		}
	}
	.el-upload__tip {
		margin-top: 0;
	}
}
.file-name {
	color: #666;
	display: flex;
	align-items: center;
	font-size: 12px;
	margin-top: 16px;
	.iconfont {
		margin-left: 4px;
		cursor: pointer;
		color: #000;
		font-size: 14px;
	}
}

.hidden {
	visibility: hidden;
}

.content-error-tip {
	user-select: none;
	p {
		font-size: 12px;
		span {
			color: #ff0000;
		}

		em {
			color: #4d6bff;
			cursor: pointer;
		}
	}
}
</style>

<style lang="scss">
.gc-customer-cascader {
	.el-cascader-panel {
		.el-cascader-menu {
			&:nth-child(-n + 2) {
				display: none;
			}
			&:last-child {
				li {
					&:first-child {
						display: none;
					}
				}
			}
		}
	}
}
</style>
